<template>
  <div class="relative z-10">
    <ClickPopoverButton @open="focusMinPrice">
      <template #button>
        <div class="flex items-center text-xs font-medium text-gray-700">
          <CheckCircleIcon v-if="filtersPresent" class="w-4 h-4 mr-2 text-primary" />
          <PlusCircleIcon v-else class="w-4 h-4 mr-2" />
          <span>Prix</span>
        </div>
      </template>
      <template #content>
        <div class="p-3 rounded-xl shadow-sm bg-white w-full max-w-md">
          <div class="text-sm font-medium mb-3">Filtrer par prix</div>
          <div class="flex flex-col space-y-2">
            <div class="flex flex-col space-y-2">
              <label class="text-xs text-gray-600">Supérieur à</label>
              <div class="relative">
                <input
                  ref="minPriceInput"
                  v-model="minPriceFilter"
                  type="number"
                  placeholder="0"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs focus:outline-hidden focus:ring-primary focus:border-primary"
                />
                <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">€</span>
              </div>
            </div>
            <div class="flex flex-col space-y-2">
              <label class="text-xs text-gray-600">Inférieur à</label>
              <div class="relative">
                <input
                  v-model="maxPriceFilter"
                  type="number"
                  placeholder="0"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs focus:outline-hidden focus:ring-primary focus:border-primary"
                />
                <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">€</span>
              </div>
            </div>
            <div class="flex justify-between">
              <SecondaryButton @click="applyFilter">Appliquer</SecondaryButton>
              <SecondaryButton v-if="filtersPresent" @click="resetFilter">Effacer</SecondaryButton>
            </div>
          </div>
        </div>
      </template>
    </ClickPopoverButton>
  </div>
</template>

<script>
import { SecondaryButton, ClickPopoverButton } from "@estaly/ui";
import { mapActions, mapMutations, mapState } from "vuex";
import { PlusCircleIcon } from "@heroicons/vue/outline";
import { CheckCircleIcon } from "@heroicons/vue/solid";

export default {
  components: { CheckCircleIcon, PlusCircleIcon, ClickPopoverButton, SecondaryButton },

  data() {
    return {
      minPriceFilter: null,
      maxPriceFilter: null,
    };
  },

  computed: {
    ...mapState("products", ["minPrice", "maxPrice"]),

    filtersPresent() {
      return this.maxPrice || this.minPrice;
    },
  },

  methods: {
    ...mapMutations("products", ["setMinPrice", "setMaxPrice"]),
    ...mapActions("products", ["updatePriceFilter"]),

    resetFilter() {
      this.minPriceFilter = null;
      this.maxPriceFilter = null;
      this.updatePriceFilter({ minPrice: null, maxPrice: null });
    },

    applyFilter() {
      this.updatePriceFilter({
        minPrice: this.minPriceFilter,
        maxPrice: this.maxPriceFilter,
      });
    },

    focusMinPrice() {
      this.$nextTick(() => this.$refs.minPriceInput?.focus());
    },
  },

  created() {
    this.minPriceFilter = this.minPrice;
    this.maxPriceFilter = this.maxPrice;
  },
};
</script>
